import Black from '../../assets/vikingbet/fonts/Roboto-Black.ttf';
import BlackItalic from '../../assets/vikingbet/fonts/Roboto-BlackItalic.ttf';
import Bold from '../../assets/vikingbet/fonts/Roboto-Bold.ttf';
import BoldItalic from '../../assets/vikingbet/fonts/Roboto-BoldItalic.ttf';

import ExtraLight from '../../assets/vikingbet/fonts/Roboto-Thin.ttf';
import ExtraLightItalic from '../../assets/vikingbet/fonts/Roboto-ThinItalic.ttf';
import Light from '../../assets/vikingbet/fonts/Roboto-Light.ttf';
import LightItalic from '../../assets/vikingbet/fonts/Roboto-LightItalic.ttf';
import Regular from '../../assets/vikingbet/fonts/Roboto-Regular.ttf';
import Italic from '../../assets/vikingbet/fonts/Roboto-Italic.ttf';
import SemiBold from '../../assets/vikingbet/fonts/Roboto-Medium.ttf';
import SemiBoldItalic from '../../assets/vikingbet/fonts/Roboto-MediumItalic.ttf';
import SkranjiBold from '../../assets/vikingbet/fonts/Skranji-Bold.ttf';
import SkranjiRegular from '../../assets/vikingbet/fonts/Skranji-Regular.ttf';

export const fontFace = `
  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 100;
    font-display: swap;
    src: url('${ExtraLight}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 100;
    font-display: swap;
    src: url('${ExtraLightItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 300;
    font-display: swap;
    src: url('${Light}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 300;
    font-display: swap;
    src: url('${LightItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${Regular}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 400;
    font-display: swap;
    src: url('${Italic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url('${SemiBold}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 500;
    font-display: swap;
    src: url('${SemiBoldItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('${Bold}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 700;
    font-display: swap;
    src: url('${BoldItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: url('${Black}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 900;
    font-display: swap;
    src: url('${BlackItalic}') format('opentype');
  }

  @font-face {
    font-family: 'SkranjiBold';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('${SkranjiBold}') format('opentype');
  }

  @font-face {
    font-family: 'SkranjiRegular';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${SkranjiRegular}');
  }
`;
